<style lang="less" scoped>
  .layout-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #2a2f32;
    overflow: hidden;
    /*color: #e6451e;*/
  }
  .brand-container{
    display: inline-block;
    vertical-align: top;
    height: 34px;
    margin-left: 8px;
    margin-top: 8px;
    cursor: pointer;
  }
  .brand-container img{
    height: 100%;
  }
  .brand-name{
    display: inline-block;
    vertical-align: top;
    margin-left: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #d5d5d5;
    cursor: pointer;
  }
  .layout-body{
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .layout-body-top {
    top: 50px;
  }
  .layout-body-top-z {
    top: 0px;
  }
  .layout-ceiling-main{
    float: right;
    margin-right: 15px;
  }
  .layout-ceiling-main a{
    color: #9ba7b5;
  }
  .ivu-col{
    transition: width .2s ease-in-out;
  }
  .layout-menu-left{
    background: #464c5b;
    height: 100%;
  }
  .toggle-menu-btn{
    position: relative;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    width: 36px;
    height: 100%;
    color: white;
    cursor: pointer;
    clear: right;
  }
  .toggle-menu-btn:hover{
    color: #d5d5d5;
  }
  .toggle-menu-btn .ivu-btn-text{
    color: white;
  }
  .toggle-menu-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: .3s;
  }
  .toggle-menu-icon-fold{
    transform: translate(-50%, -50%) rotate(-90deg) scale(0.85, 1.3);
  }
  .inner-system{
    display: inline-block;
    font-size: 14px;
    color: #9ba7b5;
    margin-left: 50px;
  }
  .inner-system-item{
    color: #9ba7b5;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
  }
  .inner-system-item:hover{
    color: white;
  }
  .layout-right{
    position: relative;
    background: #eaedf1;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .layout-right-paddding {
    padding: 15px 15px 40px 15px;
  }
  .layout-right-paddding-no {
    padding: 0;
  }
  .layout-content{
    background: white;
    padding: 15px;
    min-height: 100%;
    // height: 100%;
  }
  .layout-content-padding {
    padding: 15px;
  }
  .layout-content-padding-no {
    padding: 0px;
  }
  .year{
    margin-right: 10px;
    transform: scale(2, 2);
    font-family: fantasy;
  }
  .phone-container{
    position: relative;
    /* border: 2px solid #000; */
    line-height: 1;
  }
  .phone-container img{
    display: block;
  }
  .phone-tip{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    text-align: left;
    transform: translate(-50%, 127px);
    font-weight: bold;
    font-size: 18px;
    line-height: 1.5;
    background-color: whitesmoke;
  }
  .zhanjia-qrcode{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .router-display {
    vertical-align: top;
    display: inline-block;
    overflow-x: hidden;
    text-align: center;
    transition: width 0.3s ease-in-out;
  }
  .router-unfold {
    width: 260px;
    margin-right: -50px;
  }
  .router-fold {
    width: 0;
    margin-right: 0;
  }
  .narrow-sidebar .ivu-menu-submenu-title{
    text-align: center;
  }
  .narrow-sidebar  {
    /deep/ .menu-list-container, /deep/ .layout-search{
      display: none !important;
    }
  }
  .narrow-sidebar .ivu-menu-submenu-title-icon{
    display: none;
  }
  .narrow-sidebar .ivu-menu-item{
    padding: 14px 6px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .phone-poptip{
    .ivu-poptip-arrow{
      display: none;
    }
    .ivu-poptip-body-content{
      max-height: none;
    }
    .ivu-poptip-body{
      padding: 0;
      border: 2px solid #333;
    }
  }
</style>

<template>
  <v-app
    v-show="!hidden"
    data-app="true"
    class="app-container"
    :class="{'narrow-sidebar': spanLeft < 5}"
  >
    <div
      v-if="!is_full_screen"
      class="layout-header"
    >
      <div
        class="brand-container"
        @click="goTo('/')"
      >
        <img src="./image/mis_logo.png">
      </div>
      <span
        v-if="false"
        class="brand-name"
        @click="goTo('/')"
      >
        <span
          v-if="false"
          class="year color-error"
        >
          <span>
            <Icon type="ios-color-wand" />
            <Icon type="ios-color-wand" />
            <Icon type="ios-color-wand" />
            新年快乐
            <Icon type="ios-color-wand" />
            <Icon type="ios-color-wand" />
            <Icon type="ios-color-wand" />
          </span>
        </span>
      </span>

      <div
        v-if="true"
        class="toggle-menu-btn"
        @click="toggleClick"
      >
        <Icon
          type="md-menu"
          class="toggle-menu-icon"
          :class="{'toggle-menu-icon-fold': spanLeft < 5}"
          size="24"
        />
      </div>
      <div
        class="router-display"
        :class="{
          'router-unfold':spanLeft < 5,
          'router-fold':spanLeft >=5
        }"
      >
        <RouterSelect
          :list="routerlist"
        />
      </div>
      <div
        v-if="customer.is_formal"
        class="inner-system"
      >
        <span
          v-show="false"
          class="color-error"
          style="margin-right: 10px"
        >
          <Icon type="ios-information-circle-outline" />
          付款报销申请已关闭, 将在年后开启!!!
        </span>
        <a
          class="inner-system-item"
          href="https://huajiao.baicizhan.com/talks/"
          target="_blank"
        >
          <Icon type="md-microphone" />
          斩家对话
        </a>
        <a
          class="inner-system-item"
          href="https://huajiao.baicizhan.com/video/"
          target="_blank"
        >
          <!-- <Icon type="md-videocam" /> -->
          <Icon type="logo-youtube" />
          视频中心
        </a>
        <Poptip
          popper-class="phone-poptip"
          trigger="hover"
          transfer
        >
          <span class="inner-system-item">
            <Icon
              type="ios-flame"
              color="red"
            />
            <!--                        <Icon type="ios-bonfire-outline" color="red" />-->
            <!--                        <Icon type="ios-phone-portrait" />-->
            企业微信版 MIS
          </span>
          <div
            slot="content"
            class="phone-poptip-content"
          >
            <div class="phone-container">
              <img
                style="width: 240px"
                :src="require('./image/mis_wx.png')"
              >
              <div class="phone-tip">
                可在【工作台】中找到MIS相关应用或在主页搜索“MIS”
              </div>
            </div>
          </div>
        </Poptip>
      </div>

      <div class="layout-ceiling-main">
        <NetworkStatus /> |
        <MailLogin /> |
        <HeaderCustomer />
      </div>
    </div>
    <Row
      :class-name="`layout-body ${!is_full_screen? 'layout-body-top':'layout-body-top-z'}`"
    >
      <i-col
        :span="spanLeft"
        :style="{
          width:(spanLeft!==5||is_full_screen)?'0%':''
        }"
        class="layout-menu-left"
      >
        <SideBar
          v-if="routerlist.length&&!is_full_screen"
          :menus="routerlist"
        />
      </i-col>
      <i-col
        :span="is_full_screen?24: spanRight"
        class="layout-right"
        :class="is_full_screen?'layout-right-paddding-no':'layout-right-paddding'"
      >
        <div
          class="layout-content"
          :class="is_full_screen?'layout-content-padding-no':'layout-content-padding'"
        >
          <AppBreadCurmb
            v-if="stand_menus.length&&!is_full_screen"
            :stand-menus="stand_menus"
          />
          <keep-alive>
            <!-- 需要缓存的视图组件 -->
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </div>
      </i-col>
    </Row>

    <qr-scaner :config="qr_scanner_config" />
    <Viewer />
    <ErrorHandler />
    <UserFlowHandler />
    <DevLogin />
    <Cable />
  </v-app>
</template>
<script>
  const env = process.env.NODE_ENV;
  import CONFIG from './config/config';
  import ErrorHandler from './views/common/error_handler';
  import NetworkStatus from './views/components/network/status';
  import MailLogin from './views/components/mail/mail_login';
  import HeaderCustomer from './views/components/header/customer';
  import SideBar from './views/components/side_bar/index';
  import AppBreadCurmb from './views/components/app_bread_curmb'
  import Viewer from './views/components/viewer/index';
  import UserFlowHandler from './views/components/flow/user_flow_handler';
  import DevLogin from './views/components/dev_login/index';
  import Cable from './views/cable/cable';
  import RouterSelect from './views/components/app_components/select_router'
  import { path_arr_vue } from '@/router'
  import {is_prod} from '@/libs/util.js'
  const timerKey = Symbol('timerKey')
  export default {
    components: { ErrorHandler, NetworkStatus, MailLogin,
                  HeaderCustomer, SideBar, Viewer,
                  UserFlowHandler, DevLogin, Cable,
                  RouterSelect, AppBreadCurmb },
    data() {
      this[timerKey] = null
      return {
        hidden: false,
        version: null,
        spanLeft: 5,
        spanRight: 19,
        customer: {
          account: '未登陆',
          groups: [],
          is_director: false,
          is_team_leader: false,
          is_formal: false
        },
        companies: [],
        companies_hash: {},
        teams: [],
        teams_hash: {},
        root_teams: [],
        root_teams_hash: {},
        jobs: [],
        jobs_hash: {},
        offices: [],
        offices_hash: {},
        qr_scanner_config: {
          show: false
        },
        loading_customer_info: false,
        try_times: 0,
      }
    },
    computed: {
      is_full_screen() {
        return this.$store.state.full_screen
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      is_login() {
        return this.customer.id;
      },
      iconSize() {
        return this.spanLeft === 5 ? 14 : 14;
      },
      routerlist() {
        return this.$store.state.click_menus
      },
      stand_menus() {
        return this.$store.state.menus
      }
    },
    watch: {
      cur_customer() {
        const user = this.cur_customer;
        if (user.id) {
          localStorage.setItem('user-id', user.id);
          localStorage.setItem('user-account', user.account);
          window.__bl.setConfig({
            setUsername: () => {
              return user.account;
            },
            uid: user.id
          });
        }
      }
    },
    created() {
      const full_screen_true = 'fullscreen=true'
      this.$store.commit('setFullScreen', location.search.slice(1).split('&').includes(full_screen_true))
      // if (!is_prod && window.location.pathname === '/update-token') {
      //   return 
      // }
      this.initApp();
      // this.$router.addRoutes(router)
    },
    methods: {
      // 获取权限树
      getAuthorityTree() {
        let index = 0
        const getdata = () => this.$util.ajax.get(this.$util.api.route_app_auth_info, {
          params: {
            app_token: CONFIG.app_token,
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const { app } = res.data || {}
            const items = ((app || {}).items) || []
            this.$store.commit('setAuthorityTree', {data:items, callBack:this.routerAuthCall});
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          if (index < 5) {
            index++
            getdata()
          }
          console.log(e);
        });
        getdata()
      },
      // 路由鉴权
      routerAuthCall(hashAuth) {
        // vue-router参数
        const locationCurrentRoute = {}
        locationCurrentRoute.path = location.pathname
        const locationQuery = {}
        const search_arr = location.search.slice(1) ? location.search.slice(1).split('&') : []
        search_arr.forEach((item) => {
          const arr = item.split('=')
          locationQuery[arr[0]] = arr[1]
        })
        let queryClone = Object.keys(locationQuery).reduce((total, key) => { // 拼接query
          if (key === 'rt') {
            return total
          }
          return total + `${total ? '&' : ''}${key}=${locationQuery[key]}`
        }, '')
        queryClone = queryClone + `${queryClone ? '&' : ''}rt=${+new Date()}`
        /* -- 路由鉴权 并动态加载 -- */
        const arr = []
        for (let i = 0; i < path_arr_vue.length; i++) {
          const routerItem = path_arr_vue[i]
          if (routerItem.noChkout) {
            continue
          }
          if (hashAuth[routerItem.path]) {
            arr.push(routerItem)
          }
        }
        this.$router.addRoutes(arr)
        /* -- 路由跳转 -- */
        setTimeout(() => {
          this.$router.push(locationCurrentRoute.path + `?${queryClone}`)
        })
      },
      sizeChange() {
        return setTimeout(() => {
          this.calcWindowSize();
          this[timerKey] = null
        }, 500)
      },
      initApp() {
        this.calcWindowSize()
        this.initEvents();
        this.getCurCustomerInfo();
        this.getAuthorityTree()
        //this.getBaseInfo();
        this.$Message.config({top: 30, duration: 5});
      },
      calcWindowSize() {
        this.$store.commit('setWindowHeight', window.innerHeight);
        this.$store.commit('setWindowWidth', window.innerWidth);
      },
      initEvents() {
        document.addEventListener("visibilitychange", () => {
          console.log(document.visibilityState);
          if (document.visibilityState === "hidden") {
            console.log('窗口隐藏');
          } else if (document.visibilityState === "visible") {
            console.log('窗口显示');
            this.checkUpdate();
          }
        });
        eventHub.$on('hideApp', () => {
          this.hidden = true
        });
        eventHub.$on('showApp', () => {
          this.hidden = false
        });
        window.onresize = () => {
          const _onresize = this.sizeChange
          if (this[timerKey]) {
            clearTimeout(this[timerKey])
          }
          this[timerKey] = _onresize()
        };
        // 路由
        this.$router.beforeEach((to, from, next) => {
          const path_hash = this.$store.state.path_hash || {}
          const item = path_hash[to.path] || {}
          const title = item.name || 'MIS'
          document.title = title
          window.__bl.setConfig({
            tag: title
          });
          next()
        })
      },
      getCurCustomerInfo() {
        if (!this.loading_customer_info && this.try_times < 3) {
          this.loading_customer_info = true;
          this.$util.ajax.get(this.$util.api.get_customer_infos, {
            //
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.loading_customer_info = false;
            if (res.code === 1) {
              const data = res.data;
              if (this.$util.isObject(data)) {
                this.customer = data;
                this.version = data.version;
                this.$store.commit('setCurCustomer', data);
              } else {
                // todo 判断没有权限的情况下不调转登录页
                window.location.href = 'https://home.baicizhan.com/login?service=https://mis.baicizhan.com'
              }
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading_customer_info = false;
            this.try_times++;
            this.getCurCustomerInfo();
            console.log(e);
          });
        }
      },
      checkUpdateInterval() {
        if (env === 'development') return;
        // 每隔几分钟检查一次是否有更新
        const several_minutes = 3 * 60 * 1000;
        this.check_update_timer = setInterval(() => {
          this.checkUpdate();
        }, several_minutes);
      },
      checkUpdate() {
        this.$util.ajax.get(this.$util.api.check_system_update, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            if (data.version) {
              if (this.version) {
                if (this.version !== data.version) {
                  const notice_name = 'system-update-notice';
                  this.$Notice.close(notice_name);
                  this.$Notice.info({
                    name: notice_name,
                    title: `系统更新(V.${data.version.replace('↵', '')})`,
                    desc: '请及时刷新页面更新至最新版本, 否则可能会出现运行错误!',
                    render: (h) => {
                      return h('div', [
                        h('div', [
                          h('span', '请及时点击浏览器刷新按钮'),
                          h('Icon', {props: {type: 'md-refresh', size: 24}}),
                          h('span', '更新至最新版本')
                        ]),
                        h('div', {
                          'class': {
                            'hr': true
                          }
                        }),
                        h('Button', {
                          props: {
                            size: 'small',
                            type: 'primary',
                            ghost: true
                          },
                          on: {
                            click: () => {
                              window.location.reload();
                            }
                          }
                        }, '立即更新')
                      ]);
                    },
                    duration: 0
                  });
                  //clearInterval(this.check_update_timer);
                }
              }
              this.version = data.version;
            }
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      toggleClick() {
        if (this.spanLeft === 5) {
          this.spanLeft = 0;
          this.spanRight = 24;
        } else {
          this.spanLeft = 5;
          this.spanRight = 19;
        }
        setTimeout(() => {
          eventHub.$emit('menu-resize');
        }, 500);
      },
      goTo(path) {
        this.$router.push({
          path: path,
          query: {
            rt: new Date().getTime()
          }
        });
      },
      startQrScaner() {
        eventHub.$emit('show-qr-scaner');
      },
    }
  };
</script>
